/**
 * -----------------------------------------------------------------------------
 * This renders UAEFlag as svg
 * TODO: @Sowed need to replace this with a better svg icon
 */
export function UAEFlagIcon() {
  return (
    <svg
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect fill="url(#pattern0_296_256)" height="20" rx="10" width="20" />
      <defs>
        <pattern
          height="1"
          id="pattern0_296_256"
          patternContentUnits="objectBoundingBox"
          width="1"
        >
          <use
            transform="scale(0.00480769 0.0078125)"
            xlinkHref="#image0_296_256"
          />
        </pattern>
        <image
          height="128"
          id="image0_296_256"
          width="255"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAACABAMAAAA2UqLtAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAIVBMVEX/AADAHAwAcy/VKB1VonT/Pz/////VFRVUVFTAAAAAAADVhKcTAAAAAWJLR0QGYWa4fQAAAAd0SU1FB+IMFQouMvsoh/8AAACBSURBVHja7c4xDYAwEADAJ4QQXBCUMFQIEzoYkcGMyjqg04cOdwou4tuw5VpDQEBAQEBAQEBAQEBAQEBAQEBAQKD3wFhy7a3AdOY6BAQEBAQEBAQEBAQEBAQEBAQEBAS6D8x3rqsVWN5cj4CAgICAgICAgICAgICAgICAgIDA74EKhLEgnmVe7/cAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTItMjFUMTA6NDY6NTArMDA6MDDAlan5AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTEyLTIxVDEwOjQ2OjUwKzAwOjAwscgRRQAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
}
